import { render, staticRenderFns } from "./CardCompetencia.vue?vue&type=template&id=ae937c8c&scoped=true&"
import script from "./CardCompetencia.vue?vue&type=script&lang=js&"
export * from "./CardCompetencia.vue?vue&type=script&lang=js&"
import style0 from "./CardCompetencia.vue?vue&type=style&index=0&id=ae937c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae937c8c",
  null
  
)

export default component.exports